import { Link, Page, LegacyCard, DataTable, HorizontalStack, Avatar, Text, Badge, Pagination } from '@shopify/polaris';
import { useState, useCallback } from 'react';
import { numberToUSD } from '../utils';

export default function AffiliateTable({ discountCodes }) {

  const [sortedRows, setSortedRows] = useState(null);
  const [page, setPage] = useState(0)

  const initiallySortedRows = [];
  discountCodes?.forEach((code) => {
    code.orders?.forEach((order) => {
      initiallySortedRows.push([
        numberToUSD((Number(order.subtotalPriceSet?.shopMoney?.amount) * (code.commission / 100)) || 0),
        new Date(order.processedAt)?.toLocaleDateString(),
        <Badge status={order.commissionPaid ? 'success' : 'attention'}>{order.commissionPaid ? 'Paid' : 'Pending'}</Badge>
      ])
    })
  })
  initiallySortedRows.sort((a, b) => new Date(b[1]) - new Date(a[1])).slice(page * 10, (page + 1) * 10)

  const rows = sortedRows ? sortedRows : initiallySortedRows;
  const handleSort = useCallback(
    (index, direction) =>
      setSortedRows(sortCurrency(rows, index, direction)),
    [rows],
  );

  return (
    <LegacyCard>
      <DataTable
        columnContentTypes={[
          'text',
          'text',
          'text',
        ]}
        headings={[
          'Commission',
          'Date',
          'Status',
        ]}
        rows={rows}
        // totals={rowsBy === 'shop' ? totalShopRows.map((total, index) => ![0, 3, 5].includes(index) ? '$' + total?.toFixed(2) : total) : null}
        sortable={[true, true, true, true, true, true]}
        defaultSortDirection="descending"
        initialSortColumnIndex={4}
        onSort={handleSort}
        // footerContent={`Showing ${rows.length} of ${rows.length} results`}
        hasZebraStripingOnData
        increasedTableDensity
      />
      <HorizontalStack align="end">
        <Pagination
          hasPrevious={page > 0}
          hasNext={rows?.length && ((page + 1) * 10) < rows?.length}
          onPrevious={() => setPage(page - 1)}
          onNext={() => setPage(page + 1)}
        />
      </HorizontalStack>
    </LegacyCard>
  );

  function sortCurrency(
    rows,
    index,
    direction,
  ) {
    return [...rows].sort((rowA, rowB) => {
      const amountA = parseFloat((rowA[index] || 0).toString().substring(1));
      const amountB = parseFloat((rowB[index] || 0).toString().substring(1));

      return direction === 'descending' ? amountB - amountA : amountA - amountB;
    });
  }
}
